export default {
    user: localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : false,
    vueauth_token: localStorage.getItem('vueauth_token')
        ? localStorage.getItem('vueauth_token')
        : false,
    vueauth_token_expiry: localStorage.getItem('vueauth_token_expiry')
        ? localStorage.getItem('vueauth_token_expiry')
        : false,
    userId: null,
    scopes: [],
}
